import { all, takeLatest, call } from 'redux-saga/effects'
import getGiftCardDesign from 'services/gift-card-design'
import fetchData from '../helpers/fetchData'
import actions from './actions'

function* fetchGiftCardDesign({ payload }) {
  const service = () => getGiftCardDesign(payload)
  yield call(fetchData, actions.giftCardDesignApiName, service)
}

export default function* rootSaga() {
  yield all([takeLatest(actions.requestGiftCardDesign, fetchGiftCardDesign)])
}
